module.exports = __webpack_public_path__ + "static/top_about_bg-2299ff9f6f60913ee1e70e9eefae8c66.png";